export default "__VITE_ASSET__5T40I_Y8__"